export default __webpack_public_path__ + "static/join-bf5d45450326d1e252f5d6d5159bdde3.png";